import { useSelector } from 'react-redux'
import appConfigs from 'app/configs/appConfigs'
import * as R from 'ramda'
import moment from 'moment'
import { isPlanFreeTierByPlanId } from 'commons/plan'
import { hasPlanCanceled } from 'commons/useSubscription'
export const useIsPlaceRestricted = () => {
  const subscription = useSelector(R.path(['place', 'activeSubscription']))
  const plan = R.prop('plan', subscription)
  const nextBillingDate = R.prop('nextBillingDate', subscription)

  if (!appConfigs.enableRestrictPlace) {
    return false
  }

  if (isPlanFreeTierByPlanId(R.prop('id', plan))) {
    return (
      R.isNil(hasPlanCanceled(subscription)) &&
      nextBillingDate &&
      moment().isAfter(nextBillingDate)
    )
  }

  return (
    R.isNil(hasPlanCanceled(subscription)) &&
    nextBillingDate &&
    moment().isAfter(
      moment(nextBillingDate).add(appConfigs.gracePeriod, 'days'),
    )
  )
}

export const useHasStartedGracePeriod = () => {
  const subscription = useSelector(R.path(['place', 'activeSubscription']))
  const plan = R.prop('plan', subscription)
  const nextBillingDate = R.prop('nextBillingDate', subscription)

  if (!appConfigs.enableRestrictPlace) {
    return false
  }

  if (isPlanFreeTierByPlanId(R.prop('id', plan))) {
    return false
  }
  return (
    R.isNil(hasPlanCanceled(subscription)) &&
    nextBillingDate &&
    moment().isAfter(nextBillingDate)
  )
}

export const useIsPlaceInGracePeriod = () => {
  const subscription = useSelector(R.path(['place', 'activeSubscription']))
  const plan = R.prop('plan', subscription)
  const nextBillingDate = R.prop('nextBillingDate', subscription)

  if (!appConfigs.enableRestrictPlace) {
    return false
  }

  if (isPlanFreeTierByPlanId(R.prop('id', plan))) {
    return false
  }
  return (
    R.isNil(hasPlanCanceled(subscription)) &&
    nextBillingDate &&
    moment().isBetween(
      nextBillingDate,
      moment(nextBillingDate).add(appConfigs.gracePeriod, 'days'),
    )
  )
}

export const useIsPlaceExpired = () => {
  const subscription = useSelector(R.path(['place', 'activeSubscription']))
  const plan = R.prop('plan', subscription)
  const nextBillingDate = R.prop('nextBillingDate', subscription)

  if (!appConfigs.enableRestrictPlace) {
    return false
  }

  if (isPlanFreeTierByPlanId(R.prop('id', plan))) {
    return false
  }
  return (
    R.isNil(hasPlanCanceled(subscription)) &&
    nextBillingDate &&
    moment().isAfter(
      moment(nextBillingDate).add(appConfigs.expiresPlanInDay, 'days'),
    )
  )
}

export const useIsPlaceInRechargeablePeriod = () => {
  const subscription = useSelector(R.path(['place', 'activeSubscription']))
  const plan = R.prop('plan', subscription)
  const nextBillingDate = R.prop('nextBillingDate', subscription)

  if (!appConfigs.enableRestrictPlace) {
    return false
  }

  if (isPlanFreeTierByPlanId(R.prop('id', plan))) {
    return false
  }
  return (
    R.isNil(hasPlanCanceled(subscription)) &&
    nextBillingDate &&
    moment().isBetween(
      nextBillingDate,
      moment(nextBillingDate).add(appConfigs.expiresPlanInDay, 'days'),
    )
  )
}
